export default function getValueFromLocalStorage(includeText) {
  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);
    if (key.includes(includeText)) {
      return localStorage.getItem(key);
    }
  }
  return null;
}
